<template>
  <svg
    width="960"
    height="935"
    viewBox="0 0 960 935"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_8007_12753)">
      <ellipse
        cx="63.7309"
        cy="85.6153"
        rx="63.7309"
        ry="85.6153"
        transform="matrix(-0.470206 -0.882556 -0.882556 0.470206 585.054 483.492)"
        fill="#A370F7"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_8007_12753"
        x="0.00961304"
        y="0.119232"
        width="959.035"
        height="934.767"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="199.105"
          result="effect1_foregroundBlur_8007_12753"
        />
      </filter>
    </defs>
  </svg>
</template>
